import React from 'react';
import { Thead, Tr } from '@chakra-ui/react';
import { CoreTableHeaderCell } from './table-header-cell.js';

var CoreTableHeader = function CoreTableHeader(_ref) {
  var table = _ref.table,
      select = _ref.select,
      tableOptions = _ref.tableOptions,
      dataListProps = _ref.dataListProps;
  /**
   * DOM
   */

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Thead, null, Object.values(table.getHeaderGroups()).map(function (headerGroup) {
    return /*#__PURE__*/React.createElement(Tr, {
      key: headerGroup.id
    }, headerGroup.headers.map(function (header, index) {
      /**
       * Cell DOM
       */
      var key = "core-table-header-".concat(header.id, "-").concat(index);
      return /*#__PURE__*/React.createElement(CoreTableHeaderCell, {
        key: key,
        header: header,
        table: table,
        select: select,
        index: index,
        tableOptions: tableOptions,
        dataListProps: dataListProps
      });
    }));
  })));
};

export { CoreTableHeader };